<router-outlet></router-outlet>
<app-pwa-prompts></app-pwa-prompts>
<app-support-session-banner></app-support-session-banner>
<app-confirm-dialog-host></app-confirm-dialog-host>
<app-attendance-day-drawer></app-attendance-day-drawer>
